import { createSlice } from '@reduxjs/toolkit'

export const refSlice = createSlice({
    name: 'Ref',
    initialState: {
        regions : [],
    },
    reducers: {
        addRegions: (state, action) => {
            state.regions = action.payload;
        },
    },
});

export const { addRegions } = refSlice.actions;

export default refSlice.reducer;